import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=38151af2&scoped=true&"
import script from "./documents.vue?vue&type=script&lang=js&"
export * from "./documents.vue?vue&type=script&lang=js&"
import style0 from "./documents.vue?vue&type=style&index=0&id=38151af2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38151af2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38151af2')) {
      api.createRecord('38151af2', component.options)
    } else {
      api.reload('38151af2', component.options)
    }
    module.hot.accept("./documents.vue?vue&type=template&id=38151af2&scoped=true&", function () {
      api.rerender('38151af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/documents.vue"
export default component.exports